import type { CssType } from "@scripts/generated/sass-types/ssr-base";
import { _klass, _klassConditional, type _KlassProp, _klassProp } from "@scripts/react/util/classnames";

export type KlassProp = _KlassProp<CssType>;

export const klass = _klass<CssType>;
export const klassConditional = _klassConditional<CssType>;
export const klassProp = _klassProp<CssType>;
